import React from 'react';
import { Helmet } from 'react-helmet';
import Button from '../components/ui/Button';
export default function About() {
  return <main className="min-h-screen bg-white" data-id="element-357">
      <Helmet data-id="element-358">
        <title data-id="element-359">
          About Dr. Imtiaz Syed – Medico-Legal Psychiatrist & Expert Witness
        </title>
        <meta name="description" content="Learn about Dr. Imtiaz Syed, GMC psychiatrist & accredited expert witness with 20+ years' experience in medico-legal assessments." data-id="element-360" />
        <meta name="keywords" content="Dr. Imtiaz Syed, GMC registered psychiatrist expert witness UK, MedCo accredited psychiatric expert witness, Psychiatric Expert for Solicitors and Barristers, Expert Witness Psychiatrist UK" data-id="element-361" />
        <script type="application/ld+json" data-id="element-362">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Person",
              "name": "Dr. Imtiaz Syed",
              "jobTitle": "Psychiatrist & Expert Witness",
              "description": "GMC-registered psychiatrist with over 20 years of clinical experience, providing expert witness services across the UK.",
              "memberOf": [
                {
                  "@type": "Organization",
                  "name": "Royal College of Psychiatrists"
                },
                {
                  "@type": "Organization",
                  "name": "MedCo"
                },
                {
                  "@type": "Organization",
                  "name": "General Medical Council"
                }
              ],
              "knowsAbout": ["Psychiatry", "Mental Capacity Assessments", "PTSD Evaluations", "Forensic Psychiatry", "ADHD Assessments", "Expert Witness Testimony"]
            }
          `}
        </script>
      </Helmet>
      {/* Hero Section */}
      <section className="bg-primary text-white py-10 pt-24 md:pt-28" data-id="element-363">
        <div className="container mx-auto px-4" data-id="element-364">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-4 text-center" data-id="element-365">
            About Dr. Imtiaz Syed – Medico-Legal Psychiatrist & Expert Witness
          </h1>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-12" data-id="element-366">
        <div className="container mx-auto px-4" data-id="element-367">
          <div className="flex flex-col lg:flex-row gap-12" data-id="element-368">
            <div className="lg:w-1/3" data-id="element-369">
              <div className="sticky top-24" data-id="element-370">
                <div className="bg-gray-50 rounded-lg p-6 shadow-md" data-id="element-371">
                  <h3 className="text-xl font-serif font-bold text-primary mb-4" data-id="element-372">
                    Areas of Specialism
                  </h3>
                  <ul className="space-y-2 text-slate" data-id="element-373">
                    <li className="flex items-start" data-id="element-374">
                      <span className="text-secondary mr-2" data-id="element-375">•</span>
                      <span data-id="element-376">
                        Immigration Cases (psychological impact of
                        deportation/removal)
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-377">
                      <span className="text-secondary mr-2" data-id="element-378">•</span>
                      <span data-id="element-379">Deprivation of Liberty Safeguards (DoLS)</span>
                    </li>
                    <li className="flex items-start" data-id="element-380">
                      <span className="text-secondary mr-2" data-id="element-381">•</span>
                      <span data-id="element-382">Mental Capacity Assessments UK</span>
                    </li>
                    <li className="flex items-start" data-id="element-383">
                      <span className="text-secondary mr-2" data-id="element-384">•</span>
                      <span data-id="element-385">PTSD & Complex Trauma Evaluations</span>
                    </li>
                    <li className="flex items-start" data-id="element-386">
                      <span className="text-secondary mr-2" data-id="element-387">•</span>
                      <span data-id="element-388">ADHD & Autism in legal contexts</span>
                    </li>
                  </ul>
                  <div className="mt-6" data-id="element-389">
                    <Button variant="primary" href="/contact" className="w-full" data-id="element-390">
                      Instruct Dr. Syed
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:w-2/3" data-id="element-391">
              <div className="prose max-w-none" data-id="element-392">
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-393">
                  Your Trusted Medico-Legal Psychiatry Expert
                </h2>
                <p className="text-slate-dark mb-6" data-id="element-394">
                  Dr. Imtiaz Syed is a highly experienced and compassionate
                  Psychiatrist, dedicated to providing clear, impartial, and
                  expert medico-legal assessments. With over 20 years of
                  extensive experience in both clinical practice and secure
                  online consultations, Dr. Syed brings a wealth of knowledge
                  and a deep understanding to every case.
                </p>
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-395">
                  A Committed and Reputable Expert Witness
                </h2>
                <p className="text-slate-dark mb-4" data-id="element-396">
                  As a GMC-registered psychiatrist, Dr. Syed specializes in a
                  range of complex medico-legal areas, including:
                </p>
                <ul className="list-disc pl-6 mb-6 text-slate-dark" data-id="element-397">
                  <li className="mb-2" data-id="element-398">
                    <strong data-id="element-399">Immigration Cases:</strong> Assessing the profound
                    psychological impact of removal or deportation, and
                    evaluating potential risks upon return to an individual's
                    home country.
                  </li>
                  <li className="mb-2" data-id="element-400">
                    <strong data-id="element-401">Deprivation of Liberty Safeguards (DoLS):</strong>{' '}
                    Ensuring individuals' rights are upheld by conducting
                    thorough assessments regarding their capacity to make
                    decisions within the framework of the Mental Capacity Act
                    2005.
                  </li>
                  <li data-id="element-402">
                    <strong data-id="element-403">Mental Capacity Assessments:</strong> Meticulously
                    evaluating an individual's ability to understand, retain,
                    use, and weigh information to make specific decisions.
                  </li>
                </ul>
                <p className="text-slate-dark mb-6" data-id="element-404">
                  Dr. Syed is committed to delivering independent and
                  evidence-based psychiatric evaluations. He provides detailed,
                  objective reports for solicitors, legal teams, and courts,
                  always aiming to clarify complex medical and legal questions
                  with precision and clarity.
                </p>
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-405">
                  Convenient & Professional Online Consultations
                </h2>
                <p className="text-slate-dark mb-6" data-id="element-406">
                  Understanding the importance of accessibility and convenience,
                  Dr. Syed expertly conducts assessments remotely via secure
                  platforms such as Zoom, Skype, and WhatsApp Video Call. This
                  ensures that clients can receive high-standard, professional
                  evaluations from the comfort of their own environment,
                  wherever they are. His evaluations thoughtfully address
                  crucial aspects such as mental health conditions, trauma
                  history, cognitive abilities, and essential risk factors like
                  self-harm or suicidal ideation.
                </p>
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-407">
                  Your Assurance of Quality and Integrity
                </h2>
                <p className="text-slate-dark mb-6" data-id="element-408">
                  Dr. Syed takes immense pride in delivering reports that are
                  not only comprehensive and tailored to legal requirements but
                  are also clear, impartial, and robustly objective. He is also
                  experienced in providing expert testimony when required,
                  working closely and effectively with solicitors to ensure all
                  case details are thoroughly understood and presented.
                </p>
                <p className="text-slate-dark mb-6" data-id="element-409">
                  With a long-standing career built on trust and ethical
                  practice, Dr. Syed ensures the utmost confidentiality,
                  meticulous attention to detail, and strict adherence to the
                  highest ethical and professional standards in all his work. He
                  is a reliable and highly respected choice for medico-legal
                  psychiatric cases.
                </p>
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-410">
                  Commitment to Excellence
                </h2>
                <p className="text-slate-dark mb-6" data-id="element-411">
                  Dr. Syed is dedicated to providing independent, impartial, and
                  evidence-based reports. He is experienced in expert witness
                  testimony in Criminal, Civil, Family, and Immigration courts,
                  ensuring his insights are valuable and accessible in diverse
                  legal contexts.
                </p>
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-412">
                  Accessibility & Professionalism
                </h2>
                <p className="text-slate-dark mb-6" data-id="element-413">
                  Dr. Syed offers a range of consultation options to meet your
                  needs, including remote consultations, in-person clinics,
                  prison visits, and home visits across the UK. This flexibility
                  ensures that high-quality psychiatric assessment is accessible
                  regardless of circumstances or location.
                </p>
                <h2 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-414">
                  Ready to Discuss Your Needs?
                </h2>
                <p className="text-slate-dark mb-6" data-id="element-415">
                  Dr. Syed welcomes the opportunity to discuss your specific
                  requirements and how his expertise can assist your case.
                  Please feel free to contact him directly through our contact
                  page.
                </p>
                <div className="mt-8" data-id="element-416">
                  <Button variant="primary" size="lg" href="/contact" data-id="element-417">
                    Instruct Dr. Syed
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>;
}